// extracted by mini-css-extract-plugin
export default {"hoverInfo":"HoverInfo_hoverInfo__noDwV","hoverText":"HoverInfo_hoverText__-LOo1","copy":"HoverInfo_copy__MBViP","left":"HoverInfo_left__LUdbY","center":"HoverInfo_center__3eSE7"};